"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var getDateString = function getDateString(date) {
  if (typeof date === 'string') {
    return date;
  } else if (date instanceof Date) {
    var year = '' + date.getFullYear();
    var month = '' + (date.getMonth() + 1);
    var day = '' + date.getDate();
    if (month.length < 2) {
      month = '0' + month;
    }
    if (day.length < 2) {
      day = '0' + day;
    }
    return "".concat(year, "-").concat(month, "-").concat(day);
  } else {
    return null;
  }
};
var _default = exports["default"] = getDateString;